var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 17.5H13M20.989 10.5C21 11.077 21 11.7365 21 12.5C21 15.3003 21 16.7004 20.455 17.77C19.9757 18.7108 19.2108 19.4757 18.27 19.955C17.2004 20.5 15.8003 20.5 13 20.5H11C8.19974 20.5 6.79961 20.5 5.73005 19.955C4.78924 19.4757 4.02433 18.7108 3.54497 17.77C3 16.7004 3 15.3003 3 12.5C3 11.7365 3 11.077 3.01105 10.5M20.989 10.5C20.9595 8.96078 20.8514 8.00797 20.455 7.23005C19.9757 6.28924 19.2108 5.52433 18.27 5.04497C17.2004 4.5 15.8003 4.5 13 4.5H11C8.19974 4.5 6.79961 4.5 5.73005 5.04497C4.78924 5.52433 4.02433 6.28924 3.54497 7.23005C3.14859 8.00797 3.04052 8.96078 3.01105 10.5M20.989 10.5H3.01105",
    stroke: "#35d269",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.272096d6b3a2339a03d655fc02f95019.svg";
export { ForwardRef as ReactComponent };